import { render, staticRenderFns } from "./ExtractHeader.vue?vue&type=template&id=06315004&scoped=true"
import script from "./ExtractHeader.vue?vue&type=script&lang=js"
export * from "./ExtractHeader.vue?vue&type=script&lang=js"
import style0 from "./ExtractHeader.vue?vue&type=style&index=0&id=06315004&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06315004",
  null
  
)

export default component.exports